import { EProductTourTargets } from '@constants';
import { useTranslation } from 'react-i18next';

import { WidgetTitle, WidgetWrapper } from '../../../shared/WidgetShared.styles';
import { ShowInformation } from '../ShowInformation';

import { LiveClassesProgressChart } from './components/LiveClassesProgressChart';
import { LoadingCircleSpinnerWrapper } from './ProgressFp.styles';

import CLASS_ICON from '@/assets/class_icon.svg';
import { LoadingCircleSpinner } from '@/components/Loaders';
import { useStudentLiveClassesStats, useStudentDeliverablesStats } from '@/store';

export const ProgressFp = () => {
  const { t } = useTranslation('StudentDashboardTranslations');

  const {
    seenClasses,
    totalClasses,
    notSeenClasses,
    isLoading: isLoadingLiveClassesStats
  } = useStudentLiveClassesStats();
  const {
    totalDeliverables,
    totalDeliverablesCompleted,
    isLoading: isLoadingDeliverablesStats
  } = useStudentDeliverablesStats();

  return (
    <WidgetWrapper id={EProductTourTargets.PROGRESS_WIDGET}>
      <WidgetTitle>{t('TOTAL_PROGRESS')}</WidgetTitle>
      {isLoadingLiveClassesStats || isLoadingDeliverablesStats ? (
        <LoadingCircleSpinnerWrapper>
          <LoadingCircleSpinner />
        </LoadingCircleSpinnerWrapper>
      ) : (
        <>
          <LiveClassesProgressChart seen={seenClasses} notSeen={notSeenClasses} />
          <ShowInformation
            image={<img src={CLASS_ICON} alt="Class" />}
            bigLabel={t('SEEN_CLASSES')}
            bigPercentage={`${seenClasses}/${totalClasses}`}
          />
          <ShowInformation
            icon={'Document'}
            bigLabel={t('COMPLETED_DELIVERABLES')}
            bigPercentage={`${totalDeliverablesCompleted}/${totalDeliverables}`}
          />
        </>
      )}
    </WidgetWrapper>
  );
};
